import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@eventbrite/eds-button';

export default class PackageUpdateBanner extends React.Component {
    static propTypes = {
        heading: PropTypes.object,
        bannerCTA: PropTypes.object,
        redirectUrl: PropTypes.string,
        launchNewPackageAndPricing: PropTypes.bool,
    };

    render() {
        const { heading, bannerCTA, redirectUrl, launchNewPackageAndPricing } =
            this.props;

        return (
            !launchNewPackageAndPricing && (
                <div className="eds-g-grid">
                    <div className="eds-g-group">
                        <div className="eds-g-cell eds-g-cell-sw-9-12 eds-g-cell-12-12">
                            <span>{heading}</span>
                        </div>
                        <div className="eds-g-cell eds-g-cell-sw-3-12 eds-g-cell-12-12">
                            <span className="eds-align--right eds-align--sn-left eds-align--sm-left">
                                <Button
                                    type="link"
                                    style="anchor"
                                    href={redirectUrl}
                                >
                                    {bannerCTA}
                                </Button>
                            </span>
                        </div>
                    </div>
                </div>
            )
        );
    }
}
